import React, { FC, Fragment } from 'react';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

import * as S from './styles';

export type Crumb = { display: string; url: string };

interface Props {
  crumbs: Crumb[];
  current: string;
  showNewAboveTheFoldPdp?: boolean;
}

const trackCrumbClick = (name: string) => {
  ewAnalytics.track({
    event: ANALYTICS.EVENTS.CLICKED_LINK,
    data: {
      label: ANALYTICS.LABELS.BREADCRUMB,
      text: name,
    },
  });
};

export const Breadcrumbs: FC<Props> = ({
  crumbs,
  current,
  showNewAboveTheFoldPdp = false,
}) => (
  <S.Wrapper>
    {crumbs.map((crumb) => (
      <Fragment key={crumb.url}>
        <S.Crumb
          to={crumb.url}
          onClick={() => trackCrumbClick(crumb.display)}
          showNewAboveTheFoldPdp={showNewAboveTheFoldPdp}
        >
          {crumb.display}
        </S.Crumb>
        <S.Divider showNewAboveTheFoldPdp={showNewAboveTheFoldPdp}>
          {'/'}
        </S.Divider>
      </Fragment>
    ))}
    <S.CurrentCrumb showNewAboveTheFoldPdp={showNewAboveTheFoldPdp}>
      {current}
    </S.CurrentCrumb>
  </S.Wrapper>
);

export default Breadcrumbs;
